export default __webpack_public_path__ + "static/media/parkingl.bedb549c.png";